import { render, staticRenderFns } from "./AnalisisConsulta.vue?vue&type=template&id=0f2da334"
import script from "./AnalisisConsulta.vue?vue&type=script&lang=js"
export * from "./AnalisisConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports